<template>
  <div class="crudKeyUsers">
    <div class="row mb-3">
      <div class="col-md-12 top">
        <router-link class="return" :to="{
            name: 'KeyUser List'
          }">
          <i class="fas fa-chevron-left"></i>
          {{ $t("events.newEvent.back") }}
        </router-link>
      </div>
    </div>
    <div class="row px-5 py-3">
      <div class="col-md-12 d-flex justify-content-between">
        <h1>{{$t("keyUser.addKeyUser.title")}}</h1>
        <button class="btn-download mr-5">{{ $t("keyUser.addKeyUser.save") }}</button>
      </div>
      <div class="col-md-4 mt-5">
        <button class="btn-download mr-5">{{ $t("keyUser.addKeyUser.selectCol") }}</button>
      </div>
      <div class="col-md-8 mt-5">
        <label for="select-search-input">{{ $t("keyUser.addKeyUser.rol") }}</label>
        <v-select
          inputId="select-search-input"
          :options="[
                { label: 'Admin', value: 'admin' },
                { label: 'Super Admin', value: 'superadmin' }
              ]"
          v-model="rol"
          :placeholder="this.$t('keyUser.addKeyUser.rolPlaceholder')"
        ></v-select>
        <div class="modules mt-4">
          <p>{{ $t("keyUser.addKeyUser.moduleAccess") }}</p>
          <div class="checkboxModule">
            <label class="checkInput" v-for="(item, index) in 27" :key="index" :for="index">
              <input type="checkbox" :name="index" :id="index" />
              {{$t(`keyUser.addKeyUser.moduleNames.${index}`)}}
            </label>
          </div>
        </div>
        <div class="validity mt-4">
          <p>{{ $t("keyUser.addKeyUser.validity") }}</p>
          <div class="radios">
            <div class="gruop mr-5">
              <input
                type="radio"
                v-model="validityOption"
                value="indefinido"
                name="radio"
                id="indefinido"
              />
              <label for="indefinido">{{ $t("keyUser.addKeyUser.validityRB1") }}</label>
            </div>
            <div class="gruop mr-5">
              <input
                type="radio"
                v-model="validityOption"
                value="vigencia"
                name="radio"
                id="vigencia"
              />
              <label for="vigencia">{{ $t("keyUser.addKeyUser.validityRB2") }}</label>
            </div>
          </div>
          <div class="dates px-5" v-if="validityOption ==='vigencia'">
            <div class="dateInput">
              <label class="black">{{ $t("keyUser.addKeyUser.from") }}</label>
              <date-picker v-model="from" valuetype="format"></date-picker>
            </div>
            <div class="dateInput marLeft">
              <label class="black">{{ $t("keyUser.addKeyUser.to") }}</label>
              <date-picker v-model="to" valuetype="format"></date-picker>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      rol: null,
      validityOption: "",
      from: null,
      to: null,
    };
  },
};
</script>
<style lang="scss">
@import "vue-select/src/scss/vue-select.scss";
</style>
<style >
.crudKeyUsers .return {
  color: black;
  cursor: pointer;
}
.crudKeyUsers .return:hover {
  text-decoration: underline !important;
  color: black;
}
.crudKeyUsers .btn-download {
  padding: 0.7rem 2rem;
  background: #000;
  color: #fff;
  border: none;
  border-radius: 0px;
}
.crudKeyUsers .checkInput {
  display: flex;
  align-items: center;
}
.crudKeyUsers .checkInput input {
  margin-right: 0.5rem;
}
.v-select,
.vs--single,
.vs--searchable {
  width: 40%;
}
.vs__dropdown-toggle {
  border: none;
}
.crudKeyUsers .modules .checkboxModule {
  display: flex;
  flex-direction: column;
  height: 270px;
  flex-wrap: wrap;
  border-bottom: 1px solid #b3b3b3;
}
.crudKeyUsers .radios {
  white-space: nowrap;
  display: inline-block;
}

.crudKeyUsers .radios .gruop input {
  width: 5%;
}
.crudKeyUsers .radios .gruop span {
  margin-left: 0.5rem;
}
.crudKeyUsers .validity .dates {
  display: flex;
}
.crudKeyUsers .validity .dates .dateInput {
  display: flex;
  flex-direction: column;
}
.marLeft {
  margin-left: 6rem;
}
</style>